var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83073 2.66927C5.88521 2.66927 3.4974 5.05709 3.4974 8.0026C3.4974 10.9481 5.88521 13.3359 8.83073 13.3359C11.7762 13.3359 14.1641 10.9481 14.1641 8.0026C14.1641 5.05709 11.7762 2.66927 8.83073 2.66927ZM2.16406 8.0026C2.16406 4.32071 5.14883 1.33594 8.83073 1.33594C12.5126 1.33594 15.4974 4.32071 15.4974 8.0026C15.4974 11.6845 12.5126 14.6693 8.83073 14.6693C5.14883 14.6693 2.16406 11.6845 2.16406 8.0026ZM8.83073 4.94985C9.19892 4.94985 9.4974 5.24833 9.4974 5.61652V8.2721L11.2915 8.87015C11.6408 8.98658 11.8296 9.36413 11.7132 9.71342C11.5968 10.0627 11.2192 10.2515 10.8699 10.1351L8.61991 9.38506C8.34768 9.29432 8.16406 9.03956 8.16406 8.7526V5.61652C8.16406 5.24833 8.46254 4.94985 8.83073 4.94985Z",
    fill: "#4A5467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic-clock.2751aad5356c8cd8edad267e667cba00.svg";
export { ForwardRef as ReactComponent };